import i18n from 'helpers/i18n';
import { useEffect, useRef } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import messages from './mesages';
import { Status } from '../Styled';
import { Box } from 'components/Box';
import { print } from '../utils';
import themeColors from 'styles/colors';
import { Icon } from 'semantic-ui-react';
import { useMediaQuery } from 'react-responsive';
import { IconButton } from '@teachstonellc/component-library';
import attemptIcon from 'images/reliabilityTest/attemptIcon.svg';
import {
  ContainerSection as Section,
  SectionActions
} from 'components/Reports/Reliability/View/Styled';
import { convertToLocal } from 'helpers/date/localTimezone';

interface TopSectionProps {
  attempt: number;
  completedAt: string;
  videoTitle?: string;
  imgIcon?: string;
  testType?: 'reliability' | 'preparation';
}
function TopSection({
  attempt,
  completedAt,
  imgIcon,
  testType,
  videoTitle
}: TopSectionProps) {
  const isTablet = useMediaQuery({ minWidth: 640 });
  const location = useLocation();
  const navigate = useNavigate();
  const completedStatusRef = useRef<HTMLDivElement>(null);
  const justSubmitted = Boolean(location.state?.justSubmitted);

  // After submitting a test, focus the completed status so screen readers
  // announce it instead of restarting from the top of the page. The flag is
  // then cleared from history so reloads and back/forward don't refocus.
  useEffect(() => {
    if (!justSubmitted) {
      return;
    }

    completedStatusRef.current?.focus();
    navigate(
      {
        pathname: location.pathname,
        search: location.search,
        hash: location.hash
      },
      { replace: true, state: null }
    );
  }, [justSubmitted, location, navigate]);

  return (
    <Box
      mx={{ _: '0', lg: '48px' }}
      className={`${testType !== 'preparation' ? 'PrintTopSection' : ''}`}
    >
      <Section
        mt="8px"
        px="10px"
        py="10px"
        borderTopRadius={isTablet ? '12px' : ''}
        className="px-5 mb-2"
      >
        <SectionActions>
          <div className="grid grid-cols-12 w-full">
            <div className="self-center col-span-10 md:col-span-3">
              <img
                src={testType === 'preparation' ? imgIcon : attemptIcon}
                alt={''}
                className="mr-2 inline"
              />
              <span>
                {testType === 'preparation'
                  ? videoTitle
                  : i18n.ft(messages.attempt, { number: attempt })}
              </span>
            </div>
            <div
              ref={completedStatusRef}
              role="status"
              aria-live="polite"
              aria-atomic="true"
              tabIndex={-1}
              className="PrintTopSection self-center col-span-12 font-bold md:text-center md:col-span-6"
            >
              <Status
                iconColor={themeColors.white}
                iconBackGroundColor={themeColors.scaleBlue}
                className="mr-2"
              >
                <Icon name="check" size="tiny" className="align-middle" />
              </Status>
              {i18n.ft(messages.completed) + ' '}
              <span className="font-normal">{convertToLocal(completedAt)}</span>
            </div>
            <div className="PrintTopSection self-center absolute right-0 col-span-2 justify-self-end md:col-span-3 md:static">
              <IconButton
                icon="fa-solid fa-print"
                className="mr-2"
                onClick={print}
                aria-label={i18n.ft(messages.click)}
              />
            </div>
          </div>
        </SectionActions>
      </Section>
    </Box>
  );
}

export default TopSection;
